import { apiDelete, apiGet, apiPatch, apiPost } from 'api/service';

export function listApiKeys() {
  return apiGet('/api/api-keys/');
}

export function createApiKey(body) {
  return apiPost('/api/api-keys/', body);
}

export function updateApiKey(id, body) {
  return apiPatch(`/api/api-keys/${id}/`, body);
}

export function deleteApiKey(id) {
  return apiDelete(`/api/api-keys/${id}/`);
}

export function testApiKeyConnection(id) {
  return apiPost(`/api/api-keys/${id}/test_connection/`, {});
}
